module.exports = __webpack_public_path__ + "components/flag/static/square/kg-764f475bc3f514a4a01ad23e95dda768.svg";